var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Icon',{staticClass:"handler",style:(_vm.marginStyle),attrs:{"type":_vm.icon,"size":16},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }